import React, { Component } from "react";
import PropTypes from "prop-types";
import { createTransaction } from "../../utils/witbookingApi";
import constants from "../../utils/constants";

function createForm(url) {
  const form = document.createElement("form");
  form.setAttribute("method", "post");
  form.setAttribute("action", url);

  const target = window && window.self !== window.top ? "_parent" : "_self";
  form.setAttribute("target", target);
  return form;
}

function createInput(name, value) {
  const elem = document.createElement("input");
  elem.setAttribute("type", "hidden");
  elem.setAttribute("name", name);
  elem.setAttribute("value", value);
  return elem;
}

function createSubmitInput() {
  const elem = document.createElement("input");
  elem.setAttribute("id", "submitTpvForm");
  elem.setAttribute("type", "submit");
  elem.setAttribute("name", "submitTpv");
  elem.setAttribute("value", "");
  return elem;
}

function createRedsysForm(transaction) {
  const form = createForm(transaction.url);
  form.appendChild(createInput("Ds_SignatureVersion", "HMAC_SHA256_V1"));
  form.appendChild(createInput("Ds_MerchantParameters", transaction.merchantParameters));
  form.appendChild(createInput("Ds_Signature", transaction.signature));
  form.appendChild(createSubmitInput());
  return form;
}

function createCecaForm({ transaction, propertyTicker }) {
  const form = createForm(transaction.url);
  form.appendChild(createInput("MerchantID", transaction.merchantId));
  form.appendChild(createInput("AcquirerBIN", transaction.acquirerBin));
  form.appendChild(createInput("TerminalID", transaction.terminalId));
  form.appendChild(createInput("TipoMoneda", transaction.currency));
  form.appendChild(createInput("URL_OK", transaction.urlOk));
  form.appendChild(createInput("URL_NOK", transaction.urlNok));
  form.appendChild(createInput("Num_operacion", transaction.orderNumber));
  form.appendChild(createInput("Importe", transaction.amount));
  form.appendChild(createInput("Pago_soportado", transaction.supportedPayment));
  form.appendChild(createInput("Cifrado", transaction.encryption));
  form.appendChild(createInput("Descripcion", propertyTicker));
  form.appendChild(createInput("Exponente", transaction.exponent));
  form.appendChild(createInput("Firma", transaction.signature));
  form.appendChild(createInput("Idioma", transaction.language));
  form.appendChild(createSubmitInput());
  return form;
}

class TpvForm extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps) {
    if (this.props.submit && prevProps.submit !== this.props.submit) {
      const { propertyTicker, idReservation, url, locale } = this.props;
      createTransaction({}, { propertyTicker, idReservation, url, locale }).then(transaction => {
        let form = null;
        switch (transaction.type) {
          case constants.TPV_TYPE.REDSYS:
            form = createRedsysForm(transaction);
            break;
          case constants.TPV_TYPE.CECA:
            form = createCecaForm({ transaction, propertyTicker });
            break;
          default:
            break;
        }
        if (form) {
          document.body.appendChild(form);
          form.querySelector("#submitTpvForm").click();
        }
      });
    }
  }

  render() {
    return <div></div>;
  }
}

//TODO: Correct proptypes
// TpvForm.propTypes = {
//   propertyTicker: PropTypes.string,
//   idReservation: PropTypes.string,
//   url: PropTypes.string,
//   locale: PropTypes.string,
//   submit: PropTypes.bool,
// };

export default TpvForm;
